import { render, staticRenderFns } from "./HighlightsSnsBalloonParts.vue?vue&type=template&id=a3ef8a64&scoped=true"
import script from "./HighlightsSnsBalloonParts.vue?vue&type=script&lang=ts"
export * from "./HighlightsSnsBalloonParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsSnsBalloonParts.vue?vue&type=style&index=0&id=a3ef8a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ef8a64",
  null
  
)

export default component.exports